import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';

export function ssoDebugLog(message: string, data?: Record<string, unknown>) {
  if (getFlag(FlagType.EnableSsoDebugLogs)) {
    console.log(`[OAuth-Debug] ${message}`, data ?? '');
  }
}
